import { PanelSection } from '@dev-spendesk/grapes';
import { type FormikProps } from 'formik';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import { type BankInfosErrors } from 'modules/suppliers/models';
import type { VerificationOfPayeeResult } from 'src/core/modules/verification-of-payee/apis';

import { type FormValues } from './SupplierForm';
import { SupplierFormBankInfoFields } from './SupplierFormBankInfoFields';

type Props = {
  values: FormValues;
  errors: FormikProps<FormValues>['errors'];
  setFieldValue: FormikProps<FormValues>['setFieldValue'];
  verificationOfPayeeResult?: VerificationOfPayeeResult;
  onIgnoreVoP?: () => void;
  isCheckingVerificationOfPayee?: boolean;
};

export const BankInformationSection = ({
  values,
  errors,
  setFieldValue,
  verificationOfPayeeResult,
  onIgnoreVoP,
  isCheckingVerificationOfPayee,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <PanelSection title={t('submitMyInvoice.supplier.bankInfo')}>
      <SupplierFormBankInfoFields
        bankInfoSuggestion={values.bankInfoSuggestion}
        isCheckingVerificationOfPayee={isCheckingVerificationOfPayee}
        values={{
          bankCountry: values.bankCountry,
          accountHolderName: values.accountHolderName,
          iban: values.iban,
          bic: values.bic,
          sortCode: values.sortCode,
          accountCode: values.accountCode,
          accountNumber: values.accountNumber,
          routingNumber: values.routingNumber,
        }}
        errors={errors as BankInfosErrors}
        setFieldValue={(field, value) => setFieldValue(field, value, false)}
        verificationOfPayeeResult={verificationOfPayeeResult}
        onIgnoreVoP={onIgnoreVoP}
      />
    </PanelSection>
  );
};
